const configuraciones = {
  URL_API: 'https://api.checkassistance.mx/api/v1/',
  ELEMENTOS_POR_PAGINA: 11,
  MAPS_API_KEY: 'AIzaSyAcR_MZyuhisGMYwU0SoJWBJyVH5dEK1W4',
  URL_SOCKET: 'https://api.checkassistance.mx',
};

export default configuraciones;
